import { useWindowSizing } from '@app/hooks/useSizeWindow';
import { getListMark, MarkType, useGetListMarkQuery } from '@entities/Auto';

import { Select } from '@ui-kit/Select';
import { useSmartQuery } from '@shared/hooks/useSmartQuery';
import { useAppSelector } from '@redux/hooks';

const optionsSelect = {
  title: 'Марка',
  name: 'Mark',
  dataId: 'select-mark',
};

interface SelectMarkProps {
  valueCurrent: MarkType;
  className?: string;
  classNameValue?: string;
  handlerOnChange: (value: MarkType) => void;
}

export const SelectMark = ({ valueCurrent, className, classNameValue, handlerOnChange }: SelectMarkProps) => {
  const isMobile = useWindowSizing(990);
  const ssrData = useAppSelector(getListMark);
  const { data: listMark = [], isFetching } = useSmartQuery({
    queryHook: useGetListMarkQuery,
    params: undefined,
    initialData: ssrData.length ? ssrData : null,
  });

  const handlerSetValueCurrent = (value: string) => {
    if (value === '—') {
      handlerOnChange(null);
    }

    const mark = listMark.find(x => x.name === value);
    if (mark) {
      handlerOnChange(mark);
    }
  };

  return (
    <Select
      isScrollToSelect
      className={className}
      valueClassName={classNameValue}
      dataTestId={optionsSelect.dataId}
      isLoading={isFetching}
      key={optionsSelect.name}
      label={optionsSelect.title}
      readOnly={isMobile}
      activeValue={valueCurrent?.name || '—'}
      dataList={['—', ...[...(listMark?.map(x => x.name) as string[])]]}
      handlerValue={handlerSetValueCurrent}
      disabled={listMark.length < 1}
    />
  );
};
